import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import type { PaginationControlsBlockInterface } from '~/types/AppData/PageBuilder/PaginationControlsBlockInterface';
import Button from '~/components/Shared/Buttons/Button';

export default component$<PaginationControlsBlockInterface['props']>(
  ({ currentPage, nextButton, previousButton }): JSX.Element => {
    if (
      !nextButton?.value.url &&
      !previousButton?.value.url &&
      currentPage === 1
    ) {
      return <> </>;
    }
    return (
      <div class='flex justify-center items-center gap-4 my-8 page-builder-item px-5'>
        {previousButton?.value.url && (
          <Button
            variant='secondary'
            size='default'
            url={previousButton.value.url}
            target='_self'
            ariaLabel={`Go to previous page ${currentPage - 1}`}
            class='w-full md:w-[12.5rem] !border-primary !text-primary !font-big'
          >
            {previousButton.value.text}
          </Button>
        )}

        {nextButton?.value.url && (
          <Button
            variant='primary'
            size='default'
            url={nextButton.value.url}
            target='_self'
            ariaLabel={`Go to next page ${currentPage + 1}`}
            class='w-full md:w-[12.5rem] !font-big'
          >
            {nextButton.value.text}
          </Button>
        )}
      </div>
    );
  }
);
